export default __webpack_public_path__ + "static/media/Durable Gauntlets.e132d187.jpg";